"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _reactNativeWeb = require("react-native-web");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = {
  absoluteFill: _reactNativeWeb.StyleSheet.absoluteFill,
  absoluteFillObject: {
    position: 'absolute',
    start: 0,
    end: 0,
    top: 0,
    bottom: 0
  },
  hairlineWidth: _reactNativeWeb.StyleSheet.hairlineWidth,
  flatten: _reactNativeWeb.StyleSheet.flatten,
  create: function create(styles) {
    var platformStyles = {};
    Object.keys(styles).forEach(function (name) {
      var _styles$name = _objectSpread({}, styles[name]),
          ios = _styles$name.ios,
          android = _styles$name.android,
          web = _styles$name.web,
          style = (0, _objectWithoutProperties2["default"])(_styles$name, ["ios", "android", "web"]);

      if (ios && _reactNativeWeb.Platform.OS === 'ios') {
        style = _objectSpread(_objectSpread({}, style), ios);
      }

      if (android && _reactNativeWeb.Platform.OS === 'android') {
        style = _objectSpread(_objectSpread({}, style), android);
      }

      if (web && _reactNativeWeb.Platform.OS === 'web') {
        style = _objectSpread(_objectSpread({}, style), web);
      }

      platformStyles[name] = style;
    });
    return _reactNativeWeb.StyleSheet.create(platformStyles);
  }
};
exports["default"] = _default;